module.exports = __webpack_public_path__ + "media/images/btso-banner-e6bd78e75cf4795970c2d195b772ae02.png";